// Test IDs for the Kaid Maycock landing page

export const HOME = {
  emergentLink: 'home-emergent-link',
};

export const LANDING = {
  // Top bar
  topbar: 'landing-topbar',
  topbarPhone: 'landing-topbar-phone',
  topbarLogo: 'landing-topbar-logo',

  // Sticky mobile CTA
  stickyCta: 'landing-sticky-cta',
  stickyCallBtn: 'landing-sticky-call-btn',
  stickyEnquireBtn: 'landing-sticky-enquire-btn',

  // Hero
  hero: 'landing-hero',
  heroName: 'landing-hero-name',
  heroTagline: 'landing-hero-tagline',
  heroPhoto: 'landing-hero-photo',
  heroAppraisalBtn: 'landing-hero-appraisal-btn',
  heroCallBtn: 'landing-hero-call-btn',
  heroRatingBadge: 'landing-hero-rating-badge',

  // Stats
  stats: 'landing-stats',

  // About
  about: 'landing-about',

  // Areas
  areas: 'landing-areas',
  areaItem: 'landing-area-item',

  // Testimonials
  testimonials: 'landing-testimonials',
  testimonialCard: 'landing-testimonial-card',

  // Contact / Form
  contact: 'landing-contact',
  contactPhone: 'landing-contact-phone',
  contactEmail: 'landing-contact-email',
  contactAddress: 'landing-contact-address',
  form: 'landing-form',
  formName: 'landing-form-name',
  formPhone: 'landing-form-phone',
  formEmail: 'landing-form-email',
  formMessage: 'landing-form-message',
  formSubmit: 'landing-form-submit',
  formSuccess: 'landing-form-success',

  // Footer
  footer: 'landing-footer',
  footerFacebook: 'landing-footer-facebook',
  footerInstagram: 'landing-footer-instagram',
  footerLinkedin: 'landing-footer-linkedin',
};
